import { Mobile } from './core'
import './modules/form'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  $('a[href^="#"]').click(function() {
    var targetTop = $($(this).attr('href')).offset().top - ($.mlmi.mobile.isMobile ? 40 : 123)
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
  })

  gsap.registerPlugin(ScrollTrigger);

  function pinTableOfContents() {
    if (window.innerWidth >= 768) { // Desktop only, you can adjust the breakpoint as needed
      gsap.to('.toc', {
        scrollTrigger: {
          trigger: '.toc',
          start: "top 0px",
          endTrigger: '#commande',
          end: "top 120px",
          pin: true,
          pinSpacing: false,
          onEnter: () => document.querySelector(".toc").classList.add("active"),
            onLeave: () => document.querySelector(".toc").classList.remove("active"),
            onEnterBack: () => document.querySelector(".toc").classList.add("active"),
            onLeaveBack: () => document.querySelector(".toc").classList.remove("active")
        }
      });
    }
  }

  pinTableOfContents();

  window.addEventListener('resize', function() {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // Kill all ScrollTriggers
    pinTableOfContents(); // Re-create the pinning effect
  });
})
